<nav id="sidebar" class="{{ classSidebarValue }}">
  <ul class="list-unstyled components">
    @for (category of categories; track category; let i = $index) {
      <li
        [attr.id]="'sidebar-item-' + i"
        [ngClass]="isSelectedOption(category.order) ? 'active' : 'inactive'"
        >
        <a
          [attr.id]="'sidebar-btn-' + i"
          class="clickable"
          (click)="category.action()"
          (click)="selectItem(category.order)"
          >
          <i class="{{ category.icon }} sidebar-icon" aria-hidden="true"></i>
          @if (classSidebarValue !== 'active') {
            <span mat-menu-item style="font-size: 13px">{{
              category.label
            }}</span>
          }
        </a>
      </li>
    }
  </ul>
</nav>
